export default __webpack_public_path__ + "static/body_background-08664c2a0e147f8313ccfe59f720ee75.jpg";